export default "__VITE_PUBLIC_ASSET__0f3dad21__"